import { render, staticRenderFns } from "./suppliesFormOutsideCommon.vue?vue&type=template&id=ffdff1d4&scoped=true"
import script from "./suppliesFormOutsideCommon.vue?vue&type=script&lang=js"
export * from "./suppliesFormOutsideCommon.vue?vue&type=script&lang=js"
import style0 from "./suppliesFormOutsideCommon.vue?vue&type=style&index=0&id=ffdff1d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdff1d4",
  null
  
)

export default component.exports